<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useUpdateRoute } from '@/functions'
  import { useSupplierList } from '@/models/supplier'

  defineProps<{
    label?: string,
  }>()

  const route = useRoute()
  const { updateRoute } = useUpdateRoute()

  const { suppliers, loading, getData } = useSupplierList()
  getData()

  const selectedSupplier = computed({
    set: (supplier?: string) => updateRoute({ supplier }),
    get: () => route.query.supplier as string | undefined,
  })
</script>

<template>
  <app-select
    v-model="selectedSupplier"
    :label="label ?? 'Supplier'"
    :loading="loading">
    <option :value="undefined">
      Semua
    </option>
    <option
      v-for="supplier in suppliers"
      :key="supplier.id"
      :value="supplier.id">
      {{ supplier.name }}
    </option>
  </app-select>
</template>
